import { css } from "lit";

import { buttonStyles } from "../button/button.css";

export const userThemeButtonStyles = css`
  :host(.small) {
    --wow-button-inner-font-size: var(--sds-typography-body-size-small);
  }

  :host(.medium) {
    --wow-button-inner-font-size: var(--sds-typography-body-size-medium);
  }

  :host(.large) {
    --wow-button-inner-font-size: var(--sds-typography-body-size-large);
  }

  ${buttonStyles}

  :host(.circle) {
    aspect-ratio: 1 / 1;
  }

  :host(.circle) .preview-button,
  :host(.circle) wow-button {
    aspect-ratio: 1 / 1;
    border-radius: var(--sds-size-radius-full);
  }

  .preview-button {
    /* Inherit wow-button base styles for non-interactive mode */
    display: inline-flex;
    width: var(--wow-button-inner-width, auto);
    justify-content: center;
    align-items: center;
    gap: var(--sds-size-space-200);
    border: var(--sds-size-stroke-border) solid transparent;
    border-radius: var(--sds-size-radius-400);
    cursor: default;
    text-decoration: none;
    font: var(--sds-typography-weight-semibold) var(--sds-typography-body-size-large) / 100%
      var(--sds-typography-family-title);

    &.small {
      font-size: var(--sds-typography-body-size-small);
    }
  }
`;
